<template>
	<!-- CZ 16절: 숫자는 전부 여기서 바꾼다. KPI 숫자는 다음 월요일부터, 운영 값은 오늘부터 적용된다(지난 주 결과는 바뀌지 않는다). -->
	<div class="content sa19">
		<div class="section">
			<div class="section-tit">KPI·배정 설정</div>
			<div class="tab-btn">
				<button type="button" class="btn tab" v-bind:class="{ active: tab === 'member' }" @click="tab = 'member'">직원별 배정</button>
				<button type="button" class="btn tab" v-bind:class="{ active: tab === 'leader' }" @click="tab = 'leader'">팀장 배정</button>
				<button type="button" class="btn tab" v-bind:class="{ active: tab === 'setting' }" @click="tab = 'setting'">기준값</button>
				<button type="button" class="btn tab" v-bind:class="{ active: tab === 'absence' }" @click="tab = 'absence'">부재 일정</button>
				<button type="button" class="btn tab" v-bind:class="{ active: tab === 'log' }" @click="tab = 'log'">변경 이력</button>
			</div>

			<!-- 직원별 배정 · 팀장 배정(DC: 같은 표를 팀장만 추려 보이고 매수배정 담당 칸을 더한다) -->
			<div class="tab-con" v-if="tab === 'member' || tab === 'leader'">
				<div v-if="tab === 'leader'" class="txt-c--grey mb-1">
					※ 팀장(지정 또는 직급 '팀장')만 모았습니다. 배정 대상·추가 순번·일시정지는 직원별 배정과 같은 값입니다.
					<b>매수배정 담당</b>을 켠 사람은 주간 KPI 화면의 '신규 매수문의' 에서 문의를 등록하고, 순번·직접 배정·재배정·종결을
					하고, 누가 PASS/HOLD 인지 봅니다. 기준값·부재 일정·회의 모드는 관리자만 바꿉니다. 팀장 지정은
					<router-link to="/SystemAdmin/SystemAdmin20">팀 관리</router-link>에서 합니다.
				</div>
				<div class="txt-c--grey mb-1">
					※ 배정 대상을 켠 직원 중 PASS 인 사람에게 순서대로 신규 매수문의가 갑니다. HOLD 는 새 고객만 막고 기존 담당 고객은 그대로
					둡니다. 지난주 KPI 판정은 {{ members.kpi_start_week || '-' }} 주 마감부터 적용됩니다{{ members.kpi_active ? '' : '(아직 적용 전)' }}.
					다음 차례: <b>{{ nameOf(members.rotation && members.rotation.next) || '없음(배정 대기)' }}</b>
				</div>
				<div class="table-wrap">
					<table class="table sa19-members">
						<tr>
							<th>직원</th>
							<th>팀/직급</th>
							<th title="끄면 KPI 판정(충족/미달)에서 빠집니다. 숫자는 그대로 집계됩니다.">KPI 평가</th>
							<th>배정 대상</th>
							<th>지금 상태</th>
							<th>순번</th>
							<th title="한 바퀴에 몇 번 더 받는지(성과 우수자 추가 기회)">추가 순번</th>
							<th>일시정지</th>
							<th>지난주</th>
							<th v-if="tab === 'leader'" title="켜면 신규 매수문의 화면에서 등록·배정·재배정·종결을 할 수 있습니다">매수배정 담당</th>
						</tr>
						<tr v-for="m in memberRows" :key="'m_' + m.mem_uid">
							<td class="txt-left"><b>{{ m.mem_name }}</b></td>
							<td class="sa19-sub">{{ m.team_name || '-' }} / {{ m.rank_name || '-' }}</td>
							<td>
								<label class="input-checkbox">
									<input type="checkbox" :checked="m.kpi_on" :disabled="busy" @change="setFlag(m, 'kpi_on', $event)" />
									<span class="checkbox"></span>
								</label>
							</td>
							<td>
								<label class="input-checkbox">
									<input type="checkbox" :checked="m.assign_on" :disabled="busy" @change="setFlag(m, 'assign_on', $event)" />
									<span class="checkbox"></span>
								</label>
							</td>
							<td class="txt-left">
								<b v-bind:class="statusClass(m.status)">{{ statusLabel(m.status) }}</b>
								<div v-for="(r, i) in m.reasons" :key="'r_' + m.mem_uid + i" class="sa19-reason">{{ r.text }}</div>
							</td>
							<td>
								<template v-if="m.rotation">
									{{ m.rotation.pos }}번째
									<span class="sa19-sub d-block">이번 바퀴 {{ m.rotation.used }}/{{ m.rotation.turns }}</span>
								</template>
								<span v-else class="txt-c--grey">-</span>
							</td>
							<td>
								<select class="form-control sm select sa19-turns" :value="m.extra_turns" :disabled="busy" @change="setTurns(m, $event)">
									<option v-for="t in TURN_OPTIONS" :key="'t_' + t.v" :value="t.v">{{ t.label }}</option>
								</select>
							</td>
							<td class="txt-left">
								<template v-if="m.pause_flag">
									<span class="txt-c--red">정지 중</span>
									<span class="sa19-sub">{{ m.pause_until ? m.pause_until + '까지' : '기한 없음' }}</span>
									<button type="button" class="btn btn-xxsm btn-secondary" :disabled="busy" @click="unpause(m)">해제</button>
								</template>
								<button v-else type="button" class="btn btn-xxsm btn-light" :disabled="busy" @click="openPause(m)">정지</button>
							</td>
							<td>
								<template v-if="m.last_week && m.last_week.pass_flag !== 'X'">
									<span v-if="m.last_week.pass_flag === 'Y'" class="sa19-ok">충족</span>
									<span v-else class="txt-c--red" :title="m.last_week.fail_reasons">미달</span>
									<span class="sa19-sub d-block">{{ m.last_week.min_rate == null ? '-' : m.last_week.min_rate + '%' }}</span>
								</template>
								<span v-else class="txt-c--grey">-</span>
							</td>
							<td v-if="tab === 'leader'">
								<label class="input-checkbox">
									<input type="checkbox" :checked="m.lead_manage" :disabled="busy" @change="setFlag(m, 'lead_manage', $event)" />
									<span class="checkbox"></span>
								</label>
								<span v-if="m.lead_manage && m.role !== 'leader'" class="sa19-sub d-block">팀장 아님</span>
							</td>
						</tr>
						<tr v-if="loaded.member && !memberRows.length">
							<td :colspan="tab === 'leader' ? 10 : 9">{{ tab === 'leader' ? '팀장이 없습니다. 팀 관리에서 팀장을 지정하세요.' : '재직 중인 직원이 없습니다.' }}</td>
						</tr>
					</table>
				</div>
			</div>

			<!-- 기준값 -->
			<div class="tab-con" v-if="tab === 'setting' && settings">
				<div class="txt-c--grey mb-1">
					※ 주간 KPI 숫자는 <b>다음 월요일({{ settings.next_monday }})부터</b> 적용됩니다. 이번 주와 지난 주 결과는 바뀌지 않습니다.
					운영 값(자동보류·배정 조건·유형 분류)은 오늘부터 적용됩니다. 자동보류 제외 사유·직원별 제외 한도는
					<router-link to="/SystemAdmin/SystemAdmin18">자동보류 제외 관리</router-link>에서 바꿉니다.
				</div>
				<template v-for="g in GROUPS" :key="'g_' + g.title">
					<div class="sa19-group">{{ g.title }}</div>
					<table class="table type-input sa19-set">
						<colgroup><col width="300" /><col width="160" /><col width="200" /><col /></colgroup>
						<tr>
							<th>항목</th>
							<th>지금</th>
							<th>예약된 변경</th>
							<th>새 값</th>
						</tr>
						<tr v-for="k in g.keys" :key="'k_' + k">
							<th>{{ keyDef(k).label }}</th>
							<td>{{ fmt(k, settings.current[k]) }}</td>
							<td>
								<span v-if="settings.pending[k]" class="txt-c--blue">
									{{ fmt(k, settings.pending[k].value) }} ({{ settings.pending[k].effective_from }}부터)
								</span>
								<span v-else class="txt-c--grey">-</span>
							</td>
							<td class="txt-left">
								<template v-if="keyDef(k).type === 'flag'">
									<select class="form-control sm select sa19-in" v-model="form[k]">
										<option value="Y">예</option>
										<option value="N">아니오</option>
									</select>
								</template>
								<template v-else-if="keyDef(k).type === 'monday'">
									<input type="date" class="form-control sm sa19-in" v-model="form[k]" />
								</template>
								<template v-else-if="keyDef(k).type === 'types'">
									<label v-for="t in typeOptions(k)" :key="'to_' + k + t.uid" class="input-checkbox sa19-type">
										<input type="checkbox" :value="t.uid" v-model="form[k]" />
										<span class="checkbox"></span>
										<span class="text">{{ t.name }}<template v-if="t.use !== 'Y'"> (미사용)</template></span>
									</label>
								</template>
								<template v-else>
									<input
										type="number"
										class="form-control sm sa19-in"
										:min="keyDef(k).min"
										:max="keyDef(k).max"
										:placeholder="keyDef(k).type === 'intOpt' ? '비우면 조건 없음' : ''"
										v-model="form[k]"
									/>
									<span class="sa19-unit">{{ keyDef(k).unit }}</span>
								</template>
							</td>
						</tr>
					</table>
				</template>
				<table class="table type-input sa19-set">
					<colgroup><col width="300" /><col /></colgroup>
					<tr>
						<th>변경 메모</th>
						<td><input type="text" class="form-control" maxlength="200" placeholder="예: 10월 영업회의 결정" v-model="memo" /></td>
					</tr>
				</table>
				<div class="btn-wrap">
					<button type="button" class="btn btn-sm btn-secondary" :disabled="busy" @click="resetForm">되돌리기</button>
					<button type="button" class="btn btn-sm btn-primary" :disabled="busy || !changedKeys.length" @click="saveSettings">
						{{ busy ? '저장 중' : `저장 (${changedKeys.length}개 변경)` }}
					</button>
				</div>
			</div>

			<!-- 부재 일정 -->
			<div class="tab-con" v-if="tab === 'absence'">
				<div class="txt-c--grey mb-1">※ 휴가·외부일정·부재 기간에는 신규 매수배정에서 HOLD 됩니다. 직원 본인도 주간 KPI 화면에서 등록할 수 있습니다.</div>
				<table class="table type-input">
					<colgroup><col width="120" /><col /></colgroup>
					<tr>
						<th>새 일정</th>
						<td class="txt-left sa19-abs-form">
							<select class="form-control sm select" v-model="absForm.memUid">
								<option value="">직원 선택</option>
								<option v-for="m in members.list" :key="'am_' + m.mem_uid" :value="m.mem_uid">{{ m.mem_name }}</option>
							</select>
							<select class="form-control sm select" v-model="absForm.kind">
								<option v-for="(label, k) in members.absence_kinds" :key="'ak_' + k" :value="k">{{ label }}</option>
							</select>
							<input type="date" class="form-control sm" v-model="absForm.sdate" />
							<span>~</span>
							<input type="date" class="form-control sm" v-model="absForm.edate" />
							<input type="text" class="form-control sm sa19-abs-memo" maxlength="200" placeholder="메모" v-model="absForm.memo" />
							<button type="button" class="btn btn-sm btn-primary" :disabled="busy" @click="addAbsence">등록</button>
						</td>
					</tr>
				</table>
				<div class="table-wrap">
					<table class="table">
						<tr>
							<th>직원</th>
							<th>구분</th>
							<th>기간</th>
							<th>메모</th>
							<th></th>
						</tr>
						<tr v-for="a in members.absences" :key="'ab_' + a.absence_uid">
							<td>{{ a.mem_name }}</td>
							<td>{{ members.absence_kinds[a.kind] }}</td>
							<td>{{ a.sdate }}<template v-if="a.edate !== a.sdate"> ~ {{ a.edate }}</template></td>
							<td class="txt-left">{{ a.memo || '-' }}</td>
							<td><button type="button" class="btn btn-xxsm btn-secondary" :disabled="busy" @click="delAbsence(a)">삭제</button></td>
						</tr>
						<tr v-if="!members.absences.length">
							<td colspan="5">등록된 일정이 없습니다.</td>
						</tr>
					</table>
				</div>
			</div>

			<!-- 변경 이력 -->
			<div class="tab-con" v-if="tab === 'log'">
				<div class="sa19-group">기준값 변경</div>
				<div class="table-wrap">
					<table class="table">
						<tr>
							<th>저장 시각</th>
							<th>항목</th>
							<th>값</th>
							<th>적용 시작</th>
							<th>저장한 사람</th>
							<th>메모</th>
						</tr>
						<tr v-for="h in (settings ? settings.history : [])" :key="'h_' + h.setting_uid">
							<td>{{ h.reg_at }}</td>
							<td class="txt-left">{{ keyDef(h.setting_key).label || h.setting_key }}</td>
							<td>{{ h.setting_value === '' ? '(비움)' : h.setting_value }}</td>
							<td>{{ h.effective_from }}</td>
							<td>{{ h.reg_mem_name || '-' }}</td>
							<td class="txt-left">{{ h.memo || '-' }}</td>
						</tr>
						<tr v-if="settings && !settings.history.length">
							<td colspan="6">변경 이력이 없습니다.</td>
						</tr>
					</table>
				</div>
				<div class="sa19-group">직원별 배정 설정 변경</div>
				<div class="table-wrap">
					<table class="table">
						<tr>
							<th>시각</th>
							<th>직원</th>
							<th>항목</th>
							<th>이전</th>
							<th>이후</th>
							<th>사유</th>
							<th>바꾼 사람</th>
						</tr>
						<tr v-for="l in members.logs" :key="'ml_' + l.log_uid">
							<td>{{ l.reg_at }}</td>
							<td>{{ l.mem_name }}</td>
							<td>{{ FIELD_LABEL[l.field] || l.field }}</td>
							<td>{{ l.before_val == null ? '-' : l.before_val }}</td>
							<td>{{ l.after_val == null ? '-' : l.after_val }}</td>
							<td class="txt-left">{{ l.reason || '-' }}</td>
							<td>{{ l.reg_mem_name || '-' }}</td>
						</tr>
						<tr v-if="!members.logs.length">
							<td colspan="7">변경 이력이 없습니다.</td>
						</tr>
					</table>
				</div>
			</div>
		</div>

		<!-- 일시정지 -->
		<div v-if="pause" class="popup-wrap">
			<div class="dim" @click="pause = null"></div>
			<div class="popup sm">
				<div class="popup-tit">
					{{ pause.mem_name }} 신규 배정 일시정지
					<button type="button" class="btn btn-close" @click="pause = null"><b-icon-x-lg /></button>
				</div>
				<div class="popup-con">
					<table class="table type-input">
						<colgroup><col width="35%" /><col width="65%" /></colgroup>
						<tr>
							<th>종료일</th>
							<td><input type="date" class="form-control" v-model="pause.until" /> <span class="txt-c--grey">비우면 직접 풀 때까지</span></td>
						</tr>
						<tr>
							<th>사유</th>
							<td><input type="text" class="form-control" maxlength="200" placeholder="직원 본인 화면에도 보입니다" v-model="pause.reason" /></td>
						</tr>
					</table>
					<div class="btn-wrap">
						<button type="button" class="btn btn-sm btn-secondary" @click="pause = null">취소</button>
						<button type="button" class="btn btn-sm btn-primary" :disabled="busy" @click="savePause">정지</button>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
const GROUPS = [
	{
		title: '주간 KPI (다음 월요일부터 적용)',
		keys: ['call_min_staff', 'new_min_staff', 'call_min_leader', 'new_min_leader', 'session_minutes',
			'credit_meet_sell', 'credit_meet_buy', 'credit_site', 'credit_cap_pct', 'pass_rate', 'pass_need_new', 'call_include_buyer'],
	},
	{
		title: '신규 매수배정 조건 (오늘부터 적용)',
		keys: ['kpi_start_week', 'assign_unhandled_hours', 'assign_overdue_max'],
	},
	{
		title: '매수고객 자동보류 (오늘부터 적용)',
		keys: ['hold_days', 'hold_alert_days'],
	},
	{
		title: '기록 유형 분류 (오늘부터 적용, 진행 중인 주에도 반영)',
		keys: ['type_bld_call', 'type_bld_meet', 'type_cli_call', 'type_cli_meet', 'type_cli_site', 'type_cli_nego', 'type_cli_contract'],
	},
];
const FIELD_LABEL = {
	kpi_on: 'KPI 평가',
	assign_on: '배정 대상',
	pause_flag: '일시정지',
	pause_until: '정지 종료일',
	pause_reason: '정지 사유',
	extra_turns: '추가 순번',
	lead_manage: '매수배정 담당',
};
const TURN_OPTIONS = [0, 1, 2, 3, 4, 5].map((v) => ({ v, label: v ? `+${v}` : '없음' }));

function sameVal(a, b) {
	if (Array.isArray(a) || Array.isArray(b)) {
		const x = (a || []).map(Number).sort((p, q) => p - q);
		const y = (b || []).map(Number).sort((p, q) => p - q);
		return x.join(',') === y.join(',');
	}
	const na = a == null ? '' : String(a);
	const nb = b == null ? '' : String(b);
	return na === nb;
}

export default {
	name: 'SystemAdmin19',
	data() {
		return {
			GROUPS,
			FIELD_LABEL,
			TURN_OPTIONS,
			tab: 'member',
			busy: false,
			loaded: { member: false },
			members: { list: [], rotation: null, absences: [], logs: [], absence_kinds: {}, kpi_start_week: null, kpi_active: false },
			settings: null,
			form: {},
			memo: '',
			pause: null,
			absForm: { memUid: '', kind: 'vacation', sdate: '', edate: '', memo: '' },
		};
	},
	computed: {
		// 팀장 배정 탭: 팀장과, 팀장이 아니게 됐지만 매수배정 담당이 켜져 있는 사람(끌 수 있게).
		memberRows() {
			if (this.tab !== 'leader') return this.members.list;
			return this.members.list.filter((m) => m.role === 'leader' || m.lead_manage);
		},
		changedKeys() {
			if (!this.settings) return [];
			const keys = GROUPS.flatMap((g) => g.keys);
			// 비교 기준은 '앞으로 적용될 값'(예약이 있으면 그 값). 예약과 같은 값을 또 저장하지 않는다.
			return keys.filter((k) => !sameVal(this.form[k], this.baseOf(k)));
		},
	},
	created() {
		this.loadMembers();
		this.loadSettings();
	},
	methods: {
		keyDef(k) {
			return (this.settings && this.settings.keys.find((x) => x.key === k)) || {};
		},
		baseOf(k) {
			const p = this.settings.pending[k];
			return p ? p.value : this.settings.current[k];
		},
		fmt(k, v) {
			const d = this.keyDef(k);
			if (d.type === 'types') {
				const all = [...this.settings.types.building, ...this.settings.types.buyer];
				const names = (v || []).map((u) => (all.find((t) => t.uid === u) || {}).name || u);
				return names.length ? names.join(', ') : '(없음)';
			}
			if (d.type === 'flag') return v === 'Y' ? '예' : '아니오';
			if (v == null || v === '') return d.type === 'intOpt' ? '조건 없음' : '-';
			return `${v}${d.unit ? ' ' + d.unit : ''}`;
		},
		typeOptions(k) {
			const d = this.keyDef(k);
			return d.cfg && d.cfg[0] === 'building' ? this.settings.types.building : this.settings.types.buyer;
		},
		nameOf(uid) {
			const m = this.members.list.find((x) => x.mem_uid === uid);
			return m ? m.mem_name : '';
		},
		statusLabel(s) {
			return { PASS: 'PASS', HOLD: 'HOLD', OFF: '배정 대상 아님' }[s] || s;
		},
		statusClass(s) {
			return { PASS: 'sa19-ok', HOLD: 'txt-c--red', OFF: 'txt-c--grey' }[s] || '';
		},
		async loadMembers() {
			const re = await this.$apiGET('/admin/api/kpi/members');
			if (!re || !re.list) return;
			this.members = re;
			this.loaded.member = true;
		},
		async loadSettings() {
			const re = await this.$apiGET('/admin/api/kpi/settings');
			if (!re || !re.keys) return;
			this.settings = re;
			this.resetForm();
		},
		resetForm() {
			const f = {};
			for (const g of GROUPS) {
				for (const k of g.keys) {
					const v = this.baseOf(k);
					f[k] = Array.isArray(v) ? v.slice() : (v == null ? '' : v);
				}
			}
			this.form = f;
			this.memo = '';
		},
		async saveSettings() {
			const keys = this.changedKeys;
			if (!keys.length) return;
			const lines = keys.map((k) => `· ${this.keyDef(k).label}: ${this.fmt(k, this.baseOf(k))} → ${this.fmt(k, this.form[k])}`);
			const weekKeys = keys.filter((k) => this.keyDef(k).kind === 'week');
			const msg = `${lines.join('\n')}\n\n${weekKeys.length ? `KPI 숫자는 ${this.settings.next_monday} 부터, ` : ''}나머지는 오늘부터 적용됩니다. 저장할까요?`;
			if (!confirm(msg)) return;
			const values = {};
			for (const k of keys) values[k] = this.form[k];
			this.busy = true;
			try {
				const re = await this.$apiPOST('/admin/api/kpi/settings', { values, memo: this.memo });
				if (!re || !re.ok) return;
				await this.loadSettings();
				this.loadMembers();
			} finally {
				this.busy = false;
			}
		},
		async postMember(body) {
			this.busy = true;
			try {
				const re = await this.$apiPOST('/admin/api/kpi/member', body);
				if (!re || !re.ok) return false;
				await this.loadMembers();
				return true;
			} finally {
				this.busy = false;
			}
		},
		async setFlag(m, field, ev) {
			const on = ev.target.checked;
			const label = FIELD_LABEL[field];
			if (!confirm(`${m.mem_name}의 ${label}을(를) ${on ? '켭니다' : '끕니다'}.`)) {
				ev.target.checked = !on;
				return;
			}
			const ok = await this.postMember({ memUid: m.mem_uid, [field]: on ? 'Y' : 'N' });
			if (!ok) ev.target.checked = !on;
			else m[field] = on;   // 다시 읽기가 실패해도 저장한 값으로 보인다(성공하면 새 목록이 덮는다)
		},
		async setTurns(m, ev) {
			const n = Number(ev.target.value);
			const ok = await this.postMember({ memUid: m.mem_uid, extra_turns: n });
			if (!ok) ev.target.value = m.extra_turns;
			else m.extra_turns = n;
		},
		openPause(m) {
			this.pause = { mem_uid: m.mem_uid, mem_name: m.mem_name, until: '', reason: '' };
		},
		async savePause() {
			const p = this.pause;
			const ok = await this.postMember({ memUid: p.mem_uid, pause_flag: 'Y', pause_until: p.until, pause_reason: p.reason, reason: p.reason });
			if (ok) this.pause = null;
		},
		async unpause(m) {
			if (!confirm(`${m.mem_name}의 일시정지를 풉니다.`)) return;
			await this.postMember({ memUid: m.mem_uid, pause_flag: 'N' });
		},
		async addAbsence() {
			const f = this.absForm;
			if (!f.memUid) return alert('직원을 고르세요.');
			if (!f.sdate) return alert('시작일을 입력하세요.');
			this.busy = true;
			try {
				const re = await this.$apiPOST('/admin/api/kpi/absence/add', { ...f, edate: f.edate || f.sdate });
				if (!re || !re.ok) return;
				this.absForm = { memUid: '', kind: 'vacation', sdate: '', edate: '', memo: '' };
				await this.loadMembers();
			} finally {
				this.busy = false;
			}
		},
		async delAbsence(a) {
			if (!confirm(`${a.mem_name}의 ${this.members.absence_kinds[a.kind]} 일정을 삭제합니다.`)) return;
			this.busy = true;
			try {
				const re = await this.$apiPOST('/admin/api/kpi/absence/del', { absenceUid: a.absence_uid });
				if (!re || !re.ok) return;
				await this.loadMembers();
			} finally {
				this.busy = false;
			}
		},
	},
};
</script>

<style lang="scss">
@import "@/assets/css/design-tokens.scss";

.sa19 {
	// 공통 규칙 .table td(가운데)·.table .form-control.sm(200px)이 단일 클래스보다 앞서므로 표 안에서는 한 단 높여 적는다.
	.table td.txt-left,
	.table th.txt-left {
		text-align: left;
	}
	.table .form-control.sa19-turns {
		width: 80px;
	}
	.table .form-control.sa19-in {
		width: 140px;
	}
	.sa19-sub {
		@include dt-type-dense;
		color: $dt-color-ink-faint;
		white-space: nowrap;
	}
	.sa19-ok {
		color: $dt-color-success-ink;
		font-weight: 600;
	}
	.sa19-reason {
		@include dt-type-dense;
		color: $dt-color-danger;
	}
	.sa19-members td {
		white-space: nowrap;
	}
	.sa19-turns {
		width: 80px;
		display: inline-block;
	}
	.sa19-group {
		@include dt-type-section-title;
		font-size: 15px;
		margin: $dt-spacing-section 0 $dt-spacing-cell-head;
	}
	.sa19-set td {
		text-align: left;
	}
	.sa19-in {
		display: inline-block;
		width: 140px;
	}
	.sa19-unit {
		margin-left: 6px;
		color: $dt-color-ink-faint;
	}
	.sa19-type {
		margin-right: 14px;
	}
	.sa19-abs-form {
		display: flex;
		gap: 6px;
		align-items: center;
		.form-control {
			width: auto;
		}
	}
	.sa19-abs-memo {
		flex: 1 1 200px;
	}
}
</style>
